import { useEffect, useState, useRef } from "react";
import { Col, Row, Overlay, Button, Popover } from "react-bootstrap";
import { connect } from "react-redux";
import { Formik, Form } from "formik";
import FormikControl from "../../../../layouts/Input/FormikControl";
import storage from "../../../../apis/Storage";
import {
  GET_DISTRIBUTOR_DDL,
  GET_DISTRIBUTIONCENTER_DDL,
  GET_DELIVERYMAN_TILL_DDL,
} from "../../../../Types";
import { formatDate, renderCell,renderHeader } from "../../../../utilities/FUNCTIONS";
import ServerSideDataTable from "../../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import { getDropdownList } from "../../../Shared/dropdownListActions";
import { Link } from "react-router-dom";
import { isPermittedPage } from "../../../../apis/Utility";
import {
  GetDayWiseDeliverymanUniqueShopsReport,
  exportReport,
} from "./DayWiseDeliverymanUniqueShopsReportActions";
import { useHistory } from "react-router-dom";

const DayWiseDeliverymanUniqueShopsReport = (props) => {
  const userRights = JSON.parse(storage.get("_userRights"));
  const [target, setTarget] = useState(null);
  const [show, setShow] = useState(false);
  const ref = useRef(null);
  // pagination states
  const [currentIndex, setCurrentIndex] = useState();
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [searchText, setSearchText] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [distributorList, setDistributorList] = useState([]);
  const [distCenterList, setDistCenterList] = useState([]);
  const [deliverymanNameList, setDeliverymanNameList] = useState([]);
  const [isApplyFilter, setIsApplyFilter] = useState(false);

  const history = useHistory();

  const [filter, setfilter] = useState({
    distributor: null,
    distCenter: null,
    deliverymanName: null,
    fromDate: new Date(),
    toDate: new Date(),
    pageNo: 0,
    searchText: null,
    isExport: false,
  });

  const openFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  function commonReset(reset = true) {
    if (reset) {
      setSearchText("");

      setfilter({
        distributor:
          userRights != null && userRights?.userType == "DistributorUser"
            ? filter.distributor
            : null,
        distCenter: null,
        deliverymanName: null,
        fromDate: new Date(),
        toDate: new Date(),
        pageNo: 0,
        searchText: null,
        isExport: false,
      });
    }
  }

  function formRequestObject(isExport = false) {
    let requestData = {
      distributor: filter.distributor?.value,
      distCenter: filter.distCenter?.value,
      deliverymanName: filter.deliverymanName?.value,
      fromDate: filter.fromDate && formatDate(filter.fromDate),
      toDate: filter.toDate && formatDate(filter.toDate),
      pageSize: currentPageSize,
      pageNo: currentPageNo,
      searchText: searchText,
      isExport: isExport,
    };
    if (userRights != null && userRights?.userType == "DistributorUser") {
      requestData = {
        ...requestData,
        distributorId: userRights?.distributorId,
      };
    }
    return requestData;
  }

  function fetchReportData(request) {
    let finalRequest = request == null ? formRequestObject() : request;
    props.GetDayWiseDeliverymanUniqueShopsReport(finalRequest);
  }

  const handleResetFilters = (resetForm) => {
    resetForm();
    commonReset();
  };

  const getData = (page) => {
    setCurrentPageNo(page);
    var request = { ...formRequestObject(), pageNo: page };
    fetchReportData(request);
  };

  const pageSizeChanged = (pageSize) => {
    setCurrentPageNo(0);
    setCurrentPageSize(pageSize);
    var request = { ...formRequestObject(), pageSize: pageSize };
    fetchReportData(request);
  };

  const searchChanged = (text) => {
    setSearchText(text);
  };

  const LoadDataByfilter = (event) => {
    setCurrentPageNo(0);
    var request = { ...formRequestObject(), pageNo: 0 };
    fetchReportData(request);
    setShow(false);
    setIsApplyFilter(true);
  };

  const Download = () => {
    let request = formRequestObject(true);
    props.exportReport(request);
  };

  useEffect(() => {
    setCurrentPageNo(0);
    fetchReportData();
  }, [searchText]);

  useEffect(() => {
    if (props.report && props.report.totalRecords > 0) {
      setTotalRecords(props.report.totalRecords);
    } else {
      setTotalRecords(0);
    }
  }, [props.report]);

  useEffect(() => {
    if (userRights != null && userRights?.userType == "DistributorUser") {
      let distributorList = props.allDistributorList.filter(
        (x) => x.value == userRights?.distributorId
      );
      if (distributorList?.length > 0) {
        setfilter({
          ...filter,
          distributor: {
            label: distributorList[0]?.label,
            value: distributorList[0]?.value,
          },
        });
      }
      setDistributorList(
        distributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    } else {
      setDistributorList(
        props.allDistributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    }
  }, [props.allDistributorList]);

  useEffect(() => {
    if (userRights != null && userRights?.userType == "DistributorUser") {
      let distCenterList = props.selectedDistCentersList.filter((x) =>
        userRights?.distCenterIds.includes(x.value)
      );
      setDistCenterList(
        distCenterList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    } else {
      setDistCenterList(
        props.selectedDistCentersList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    }
  }, [props.selectedDistCentersList]);

  useEffect(() => {
    if (props.deliverymanTills) {
      setDeliverymanNameList(
        props.deliverymanTills.map(function (item) {
          return {
            value: item.qrCode,
            label: item.fullname,
          };
        })
      );
    }
  }, [props.deliverymanTills]);

  useEffect(() => {
    props.getDropdownList(
      `api/Distributor/GetDistributorsDDL`,
      GET_DISTRIBUTOR_DDL
    );
  }, []);

  useEffect(() => {
    if (filter.distributor) {
      props.getDropdownList(
        `api/DistCenter/GetDistCentersDDL/${filter.distributor.value}`,
        GET_DISTRIBUTIONCENTER_DDL
      );
    }
    filter.distCenter = null;
    filter.deliverymanName = null;
  }, [filter.distributor]);

  useEffect(() => {
    if (filter.distCenter) {
      props.getDropdownList(
        `api/DistCenter/GetCenterDeliveryUserDDL/${filter.distCenter.value}`,
        GET_DELIVERYMAN_TILL_DDL
      );
    }
    filter.deliverymanName = null;
  }, [filter.distCenter]);

  // For Double Click
  const onRowClick = (e, rowData) => {
    let requestPrevious = {
      deliverymanId: rowData?.deliverymanId,
      deliverymanName: rowData?.deliverymanName,
      fromDate: formatDate(filter.fromDate),
      toDate: formatDate(filter.toDate),
    };

    history.push("/DlmUniqueShopsDetailReport", {
      requestPrevious,
    });

    <Link
      to={{
        pathname: "/DlmUniqueShopsDetailReport",
        state: { requestPrevious },
      }}
    ></Link>;
  };

  const columns = [
    {
      Header: "Distribution Center",
      accessor: "distcenter",
    },
    {
      Header: "Deliveryman Name",
      accessor: "deliverymanName",
    },
    {
      Header: renderHeader("Unique Shops Invoices"),
      accessor: "uniqueShopsInvoices",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: renderHeader("Unique Shops Transacted"),
      accessor: "uniqueShopstransacted",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header:  renderHeader("No of Transactions"),
      accessor: "noOfTansactions",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header:  renderHeader("% of Active Shops (Against Invoice)"),
      accessor: "percentageOfActiveShops",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header:  renderHeader("Invoices Amount"),
      accessor: "invoicesAmount",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header:  renderHeader("M2D Amount"),
      accessor: "m2DAmount",
     Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: renderHeader("M2D %"),
      accessor: "m2DPercentage",
      Cell: ({ value }) => renderCell(value, true),
    },
  ];

  return (
    <div>
      <Row>
      <Col md={{ span: 10 }} style={{ float: "left" }}>
        <h4>
          <b>Day Wise Deliveryman Unique Shops Report</b>
        </h4>
      </Col>
      </Row>
      <Row>
        <Col md={10} style={{ float: "right" }}>
          <div ref={ref}>
            <Button
              onClick={openFilterModal}
              className="m-3"
              variant="outline-primary"
            >
              <i className="fa fa-filter" />
              Filters
            </Button>

            <Overlay
              show={show}
              target={target}
              placement="bottom"
              container={ref}
              containerPadding={20}
              width="430px"
              style={{ width: "430px" }}
            >
              <Popover
                id="popover-contained"
                style={{ maxWidth: "360px", width: "300px" }}
              >
                <Popover.Header as="h3">Filters</Popover.Header>
                <Popover.Body>
                  <Formik
                    enableReinitialize
                    initialValues={filter}
                    validator={() => ({})}
                    onSubmit={LoadDataByfilter}
                  >
                    {(formik) => (
                      <Form autoComplete="off">
                        <Row>
                          {userRights == null && (
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Distributor Name"
                                name="distributor"
                                options={distributorList}
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  if (!e || !e.value) {
                                    setfilter({
                                      ...filter,
                                      distributor: null,
                                    });
                                    return;
                                  }
                                  setfilter({
                                    ...filter,
                                    distributor: {
                                      label: e.label,
                                      value: e.value,
                                    },
                                  });
                                }}
                                value={filter.distributor}
                              />
                            </Col>
                          )}

                          <Col xs={12} md={12}>
                            <FormikControl
                              formik={formik}
                              control="react-select"
                              label="Distribution Center"
                              name="distCenter"
                              options={
                                filter.distributor != null ? distCenterList : []
                              }
                              isClearable={true}
                              isSearchable={true}
                              handleOnChange={(e) => {
                                if (!e || !e.value) {
                                  setfilter({
                                    ...filter,
                                    distCenter: null,
                                  });
                                  return;
                                }
                                setfilter({
                                  ...filter,
                                  distCenter: {
                                    label: e.label,
                                    value: e.value,
                                  },
                                });
                              }}
                              value={filter.distCenter}
                            />
                          </Col>
                          <Col xs={12} md={12}>
                            <FormikControl
                              formik={formik}
                              control="react-select"
                              label="Deliveryman Name"
                              name="deliverymanName"
                              options={
                                filter.distCenter != null
                                  ? deliverymanNameList
                                  : []
                              }
                              isClearable={true}
                              isSearchable={true}
                              handleOnChange={(e) => {
                                if (!e || !e.value) {
                                  setfilter({
                                    ...filter,
                                    deliverymanName: null,
                                  });
                                  return;
                                }
                                setfilter({
                                  ...filter,
                                  deliverymanName: {
                                    label: e.label,
                                    value: e.value,
                                  },
                                });
                              }}
                              value={filter.deliverymanName}
                            />
                          </Col>
                          <Row style={{ paddingRight: 0 }}>
                            <Col xs={12} md={6}>
                              <FormikControl
                                control="date"
                                label="From Date"
                                name="fromDate"
                                handleOnChange={(value) => {
                                  setfilter({ ...filter, fromDate: value });
                                }}
                                value={filter.fromDate}
                              />
                            </Col>
                            <Col xs={12} md={6}>
                              <FormikControl
                                control="date"
                                label="To Date"
                                name="fromDate"
                                handleOnChange={(value) => {
                                  setfilter({ ...filter, toDate: value });
                                }}
                                value={filter.toDate}
                              />
                            </Col>
                          </Row>
                        </Row>
                        <div className="row" style={{ marginTop: 20 }}>
                          <div className="form-group">
                            <Link
                              onClick={handleResetFilters.bind(
                                null,
                                formik.resetForm,
                                setIsApplyFilter(false)
                              )}
                              to="#"
                              className="active"
                              style={{
                                padding: "0px",
                                marginTop: "10px",
                                float: "left",
                              }}
                            >
                              Reset
                            </Link>
                            <Link
                              onClick={() => {
                                setShow(false);
                                setTarget(null);
                                commonReset(isApplyFilter);
                              }}
                              to="#"
                              className="active"
                              style={{
                                padding: "0px",
                                marginTop: "10px",
                                float: "right",
                              }}
                            >
                              Cancel
                            </Link>
                            <div className="float-right">
                              <Button
                                type="submit"
                                className="btn btn-primary"
                                style={{
                                  marginRight: "10px",
                                  float: "right",
                                }}
                              >
                                Apply
                              </Button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Popover.Body>
              </Popover>
            </Overlay>
          </div>
        </Col>
        {isPermittedPage("Export", props.actions, props.userRole) && (
          <Col md={2} style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={Download}
              className="m-3"
              variant="outline-primary"
            >
              <i className="fa fa-download me-1" />
              Export
            </Button>
          </Col>
        )}
      </Row>
      <Row>
        <Col>
          <ServerSideDataTable
            data={props.report?.data ?? []}
            columns={columns}
            getTrProps={(event, data) => onRowClick(event, data)}
            goToPreviousPage={(val) => getData(val)}
            goToNextPage={(val) => getData(val)}
            totalRecords={totalRecords}
            pageSizeChange={(size) => pageSizeChanged(size)}
            myPageSize={currentPageSize}
            myIndex={currentIndex}
            pageNo={currentPageNo}
            searchChanged={searchChanged}
          />
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    report: state.DayWiseDeliverymanUniqueShopsReport,
    allDistributorList: state.ddlList.allDistributorList
      ? state.ddlList.allDistributorList
      : [],
    selectedDistCentersList: state.ddlList.selectedDistCentersList
      ? state.ddlList.selectedDistCentersList
      : [],
    deliverymanTills: state.ddlList.deliverymanTills
      ? state.ddlList.deliverymanTills
      : [],
  };
};

export default connect(mapStateToProps, {
  GetDayWiseDeliverymanUniqueShopsReport,
  getDropdownList,
  exportReport,
})(DayWiseDeliverymanUniqueShopsReport);
